import { filterLocalizedLifeAreas } from '@griply/utils';
import { useSortedLocalizedLifeAreas } from 'features/life-areas';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';
import { Goal } from 'shared/types/goal';

export const useFilteredLocalizedLifeAreas = (goals: Goal[]) => {
  const user = useUser();
  const lifeAreas = useSortedLocalizedLifeAreas();
  const showEmptyLifeAreas =
    !!user?.settings?.goalsOverview?.roadmap?.showEmptyLifeAreas;

  return useMemo(
    () => filterLocalizedLifeAreas(lifeAreas, { goals, showEmptyLifeAreas }),
    [goals, lifeAreas, showEmptyLifeAreas],
  );
};
